// This file is deprecated - use React Router's useNavigate, useLocation, and useParams hooks instead
// Kept for backward compatibility during migration

export const navigate = (path, params = {}) => {
  let url = path;

  // Add query parameters if provided
  const queryString = new URLSearchParams(params).toString();
  if (queryString) {
    url += `?${queryString}`;
  }

  // Perform full page navigation
  window.location.href = url;
};

export const getQueryParam = (param) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

export const getPathParam = () => {
  const path = window.location.pathname;
  const parts = path.split('/');
  return parts[parts.length - 1];
};
